import TableDynamic from "../../../components/TableDynamic";
import React from "react";
import { Dropdown, ListGroup } from "react-bootstrap";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { store } from "../../../reducer/Store";
import ApiService from "../../../services/ApiService";
import ModalFormRegisterOrUpdate from "../../../components/ModalFormRegisterOrUpdate";
import { Draggable } from "react-beautiful-dnd";
import { ToastContainer, toast } from "react-toastify";
import Utils from "../../../services/Utils";
import TypesPlvOrderRapport from "../../../components/Operations/TypesPlvOrderRapport";
const Plv = () => {
  const { dispatch, state } = React.useContext(store);
  const [showAddTypePlv, setShowAddTypePlv] = React.useState(false);
  const [showUpdateTypePlv, setShowUpdateTypePlv] = React.useState(false);
  const [showUpdateOrderRapport, setShowUpdateOrderRapport] =
    React.useState(false);
  const [typePlv, setTypePlv] = React.useState("");
  const [previousTypePlvByDefault, setPreviousTypePlvByDefault] =
    React.useState(0);
  const [typePlvByDefault, setTypePlvByDefault] = React.useState(0);
  const [typePlvId, setTypePlvId] = React.useState();
  const [errorMessage, setErrorMessage] = React.useState("");
  const [itemsList, setItemsList] = React.useState();
  const columnsName = [
    `Liste des PLV`,
    "Spécificités",
    "Ordre affichage dans rapport",
    "",
  ];
  const columns = ["name", "for_all_customer", "order", "updateAndDelete"];

  const handleClose = () => {
    setShowAddTypePlv(false);
    setShowUpdateTypePlv(false);
    setShowUpdateOrderRapport(false);
    setItemsList(state.listTypesPlv);
    setErrorMessage("");
    setTypePlv("");
    setTypePlvId("");
    setTypePlvByDefault(0);
  };

  const handleShowAddTypePlv = () => setShowAddTypePlv(true);

  const handleShowUpdateTypePlv = (tPlv) => {
    setTypePlv(tPlv.name);
    setTypePlvId(tPlv.id);
    setPreviousTypePlvByDefault(tPlv.for_all_customer);
    setTypePlvByDefault(tPlv.for_all_customer);
    setShowUpdateTypePlv(true);
  };

  const handleShowUpdateOrderRapport = () => {
    setShowUpdateOrderRapport(true);
  };

  /**
   * Cette fonction récupère la liste de tous les types de PLV pour l'année en cours.
   * Les données sont triées par ordre croissant d'ordre d'affichage.
   */
  const getAllTypesPlv = async () => {
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {},
      `operation-plv-types-by-year/${state.currentYear.value}`,
      "get"
    )
      .then(function (response) {
        dispatch({
          type: "SET_LISTTYPESPLV",
          payload: response.data.sort((a, b) => a.order - b.order),
        });
        //console.log(response.data);
        dispatch({ type: "SET_LOADER", payload: false });
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction ajoute un nouveau type de PLV pour tous les clients de l'application ou seulement pour certains, en fonction de la valeur du paramètre typePlvByDefault.
   * @param { Number } typePlvByDefault - Indique si le type de PLV doit être ajouté à tous les clients de l'application ou seulement à certains. Si la valeur est 1, le type de PLV est ajouté à tous les clients, sinon il est ajouté seulement pour le client en cours.
   * @param { String } typePlv - Le nom du type de PLV à ajouter.
   * @param { Boolean } for_all_customer - Détermine si le PLV doit être ajouter à tous les clients.
   * @param { Number } year_id - L'année à laquelle rattacher le PLV.
   */
  const addTypePlv = async () => {
    setErrorMessage("");
    var id = "";
    if (typePlvByDefault === 1) {
      id = toast.loading(
        "Ajout de la PLV " + typePlv + " à tous les clients en cours."
      );
      handleClose();
    }
    ApiService.request(
      {
        name: typePlv,
        for_all_customer: typePlvByDefault,
        year_id: state.currentYear.value,
      },
      "operation-plv-types",
      "post"
    )
      .then(function () {
        if (typePlvByDefault === 1) {
          toast.update(id, {
            render: "La PLV a été ajoutée à tous les clients avec succès.",
            type: "success",
            isLoading: false,
            autoClose: 5000,
          });
        } else {
          Utils.notifySuccess("Ajout de la PLV " + typePlv);
          handleClose();
        }
        getAllTypesPlv();
      })
      .catch(function (error) {
        console.log(error);
        if (typePlvByDefault === 1) {
          if (error.response.data.message.includes("already exists")) {
            toast.update(id, {
              render: "Un PLV existe déjà sous le nom " + typePlv + ".",
              type: "error",
              isLoading: false,
              autoClose: 5000,
            });
          } else {
            toast.update(id, {
              render:
                "Erreur lors de l'ajout de la PLV " +
                typePlv +
                " à tous les clients.",
              type: "error",
              isLoading: false,
              autoClose: 5000,
            });
            setErrorMessage("");
          }
        } else {
          Utils.notifyError("de l'ajout de la PLV " + typePlv);
          if (error.response.data.message.includes("already exists")) {
            setErrorMessage("Ce nom existe déjà.");
          }
        }
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
        }
      });
  };

  /**
   * Cette fonction permet de mettre à jour un type de PLV pour tous les clients de l'application ou seulement pour certains, en fonction de la valeur du paramètre typePlvByDefault.
   * Elle effectue une vérification avant la modification pour s'assurer qu'aucune opération n'est en cours d'utilisation de ce type de PLV, et affiche un message d'avertissement à l'utilisateur en cnséquence.
   * Si la modification est validée, un appel API est effectué pour mettre à jour le type de PLV et une notification est affichée pour informer l'utilisateur de l'état de la modification.
   * En cas d'erreur lors de l'appel API, une notification d'erreur est affichée et l'utilisateur peut être déconnecté s'il n'est pas authentifié.
   * @param { Number } typePlvByDefault - Indique si le type de PLV doit être ajouté à tous les clients de l'application ou seulement à certains. Si la valeur est 1, le type de PLV est ajouté à tous les clients, sinon il est ajouté seulement pour le client en cours.
   * @param { String } typePlv - Le nom du type de PLV à ajouter.
   * @param { Boolean } for_all_customer - Détermine si le PLV doit être ajouter à tous les clients.
   * @param { Number } year_id - L'année à laquelle rattacher le PLV.
   * @param { Number } typePlvId - Id du PLV.
   */
  const updateTypePlv = async () => {
    setErrorMessage("");
    var validateUpdateTypePlv = true;
    var message = "";
    if (
      state.listTypesPlv.filter((elt) => elt.id === typePlvId)[0]
        .operation_plvs_count > 0
    ) {
      message =
        previousTypePlvByDefault === typePlvByDefault
          ? "Ce type de PLV " +
            typePlv +
            " est utilisé sur des clients, si vous le modifiez, vous modifierez aussi les types de PLV dans les opérations en cours. Êtes-vous sûr de poursuivre ?"
          : "Ce type de PLV " +
            typePlv +
            " sera supprimé à tous les clients qui n'utilisent pas ce type de PLV dans leur opérations en cours. Êtes-vous sûr de poursuivre ?";

      if (!window.confirm(message)) {
        validateUpdateTypePlv = false;
      }
    }
    if (validateUpdateTypePlv) {
      var id = "";
      id = toast.loading("Modification de la PLV " + typePlv + " en cours.");
      handleClose();
      ApiService.request(
        {
          name: typePlv,
          for_all_customer: typePlvByDefault,
          year_id: state.currentYear.value,
        },
        "operation-plv-types/" + typePlvId,
        "put"
      )
        .then(function () {
          toast.update(id, {
            render:
              "La modification de la PLV " +
              typePlv +
              " a été effectuée avec succès.",
            type: "success",
            isLoading: false,
            autoClose: 5000,
          });

          getAllTypesPlv();
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.message.includes("already exists")) {
            toast.update(id, {
              render: "Un PLV existe déjà sous le nom " + typePlv + ".",
              type: "error",
              isLoading: false,
              autoClose: 5000,
            });
          } else {
            toast.update(id, {
              render:
                "Erreur lors de la modification de la PLV " + typePlv + ".",
              type: "error",
              isLoading: false,
              autoClose: 5000,
            });
          }
          if (error.response.data.message === "Unauthenticated.") {
            localStorage.clear();
            dispatch({ type: "SET_LOGOUT", payload: false });
          }
        });
    }
  };

  /**
   * Cette méthode permet de modifier un type de PLV pour tous les clients de l'application ou seulement pour certains, en fonction de la valeur du paramètre `updateTypePlv.for_all_customer`.
   * Si cette valeur est égale à 1, le type de PLV sera ajouté à tous les clients, sinon il sera ajouté seulement pour le client en cours.
   * La méthode effectue une requête HTTP PUT avec les informations du type de PLV modifié à l'API et met à jour la liste des types de PLV en appelant la méthode `getAllTypesPlv`.
   * Si l'utilisateur confirme l'action, un message de succès ou d'erreur est affiché en utilisant la bibliothèque `react-toastify`.
   * @param { Object } updateTypePlv - Un objet contenant les informations du type de PLV à modifier (id, name, for_all_customer, year_id).
   */
  const updateFromListTypePlv = async (updateTypePlv) => {
    if (
      window.confirm(
        updateTypePlv.for_all_customer === 1
          ? "Êtes-vous sûr de vouloir retirer ce type de PLV par défault à tous les clients ? Il sera supprimer à tous les clients sauf ceux qui l'utilisent dans une opération."
          : "Êtes-vous sûr de vouloir ajouter ce type de PLV à tous les clients ?"
      )
    ) {
      const id = toast.loading(
        "Modification de la PLV " + updateTypePlv.name + " en cours"
      );
      handleClose();
      ApiService.request(
        {
          name: updateTypePlv.name,
          for_all_customer: updateTypePlv.for_all_customer === 1 ? 0 : 1,
          year_id: updateTypePlv.year_id,
        },
        "operation-plv-types/" + updateTypePlv.id,
        "put"
      )
        .then(function () {
          if (updateTypePlv.for_all_customer === 0) {
            toast.update(id, {
              render:
                "La PLV " +
                updateTypePlv.name +
                " a été ajoutée à tous les clients avec succès.",
              type: "success",
              isLoading: false,
              autoClose: 5000,
            });
          } else {
            toast.update(id, {
              render:
                "La PLV " +
                updateTypePlv.name +
                " a été retirée à tous les clients qui ne l'utilisaient pas dans une opération.",
              type: "success",
              isLoading: false,
              autoClose: 5000,
            });
          }

          getAllTypesPlv();
        })
        .catch(function (error) {
          toast.update(id, {
            render:
              "Erreur lors de la modification, la PLV " +
              updateTypePlv.name +
              " n'a pas été ajoutée à tous les clients.",
            type: "error",
            isLoading: false,
            autoClose: 5000,
          });
          console.log(error);
          if (error.response.data.message === "Unauthenticated.") {
            localStorage.clear();
          }
        });
    }
  };

  /**
   * Cette fonction supprime un type de PLV pour tous les clients de l'application ou seulement pour certains, en fonction de la valeur du paramètre typePlvByDefault.
   * Si le type de PLV est utilisé sur des clients, un message d'avertissement est affiché pour demander confirmation avant la suppression.
   * @param {Object} tPlv - L'objet du type de PLV à supprimer, contenant son identifiant et son nom.
   */
  const deleteTypePlv = async (tPlv) => {
    var message = "";
    message =
      state.listTypesPlv.filter((elt) => elt.id === tPlv.id)[0]
        .operation_plvs_count > 0
        ? "Ce type de PLV " +
          tPlv.name +
          " est utilisé sur des clients, si vous le supprimez, vous supprimerez aussi les types de PLV dans les opérations en cours. Êtes-vous sûr ? Cela est définitif."
        : "Êtes-vous sûr de vouloir supprimer le type de PLV " +
          tPlv.name +
          " ? Cela est définitif.";
    if (window.confirm(message)) {
      var id = "";
      if (typePlvByDefault === 1) {
        id = toast.loading(
          "Suppression de la PLV " + tPlv.name + " à tous les clients en cours."
        );
        handleClose();
      }
      ApiService.request({}, "operation-plv-types/" + tPlv.id, "delete")
        .then(function () {
          if (typePlvByDefault === 1) {
            toast.update(id, {
              render: "La PLV a été supprimée de tous les clients avec succès.",
              type: "success",
              isLoading: false,
              autoClose: 5000,
            });
          } else {
            Utils.notifySuccess("Suppression de la PLV " + tPlv.name);
            handleClose();
          }
          getAllTypesPlv();
        })
        .catch(function (error) {
          if (typePlvByDefault === 1) {
            toast.update(id, {
              render:
                "Erreur lors de la suppression de la PLV " +
                tPlv.name +
                " à tous les clients.",
              type: "error",
              isLoading: false,
              autoClose: 5000,
            });
          } else {
            Utils.notifyError("de la suppresion de la PLV " + tPlv.name);
          }
          console.log(error);
          if (error.response.data.message === "Unauthenticated.") {
            localStorage.clear();
          }
        });
    }
  };

  React.useEffect(() => {
    getAllTypesPlv();
  }, [state.currentYear]);
  React.useEffect(() => {
    setItemsList(state.listTypesPlv);
  }, [state.listTypesPlv]);

  /**
   * Cette fonction est appelée lorsqu'un élément est déplacé dans une liste. Elle met à jour l'ordre des éléments dans la liste et met à jour l'état des éléments de la liste.
   * @param {Object} result - L'objet résultant du déplacement, contenant l'index source, l'index destination, ainsi que l'identifiant de l'élément déplacé.
   */
  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const { source, destination } = result;
    const reorderedItems = Array.from(itemsList);
    const [removedItem] = reorderedItems.splice(source.index, 1);
    reorderedItems.splice(destination.index, 0, removedItem);
    const updatedItems = reorderedItems.map((item, index) => ({
      ...item,
      order: index + 1,
    }));
    setItemsList(updatedItems);
  };

  /**
   * Cette fonction met à jour l'ordre des types de PLV des opérations en cours dans la base de données en appelant l'API correspondante.
   * Elle met également à jour l'état de l'application en récupérant la liste mise à jour des types de PLV.
   * @param {Object} data - Les données à envoyer à l'API pour mettre à jour l'ordre des types de PLV.
   */
  const updateOrder = (data) => {
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {
        data: data,
      },
      "operation-plv-types-update-order",
      "put"
    )
      .then(function () {
        dispatch({ type: "SET_LOADER", payload: false });
        handleClose();
        getAllTypesPlv();
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  return (
    <>
      <h1>
        PLV
        <Dropdown className="d-inline-block">
          <Dropdown.Toggle>
            <MoreVertIcon />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item onClick={handleShowAddTypePlv}>
              Ajouter un type de PLV
            </Dropdown.Item>
            <Dropdown.Item
              onClick={handleShowUpdateOrderRapport}
              disabled={itemsList && itemsList.length === 0 ? true : false}
            >
              Changer l'ordre dans le rapport
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </h1>
      <ToastContainer />

      {showUpdateOrderRapport && (
        <TypesPlvOrderRapport
          showUpdateOrderRapport={showUpdateOrderRapport}
          updateOrder={updateOrder}
          itemsList={itemsList}
          handleClose={handleClose}
          onDragEnd={onDragEnd}
          ListItem={ListItem}
        />
      )}
      {showAddTypePlv && (
        <ModalFormRegisterOrUpdate
          show={showAddTypePlv}
          registerOrUpdate={addTypePlv}
          name={typePlv}
          setName={setTypePlv}
          errorMessage={errorMessage}
          typePlvByDefault={typePlvByDefault}
          setTypePlvByDefault={setTypePlvByDefault}
          handleClose={handleClose}
          controlFormId={"add-types-plv"}
        />
      )}

      {showUpdateTypePlv && (
        <ModalFormRegisterOrUpdate
          show={showUpdateTypePlv}
          registerOrUpdate={updateTypePlv}
          name={typePlv}
          setName={setTypePlv}
          errorMessage={errorMessage}
          typePlvByDefault={typePlvByDefault}
          setTypePlvByDefault={setTypePlvByDefault}
          handleClose={handleClose}
          controlFormId={"update-types-plv"}
        />
      )}
      <TableDynamic
        updateState={updateFromListTypePlv}
        columnsName={columnsName}
        columns={columns}
        showUpdate={handleShowUpdateTypePlv}
        data={state.listTypesPlv}
        deleteD={deleteTypePlv}
      ></TableDynamic>
    </>
  );
};

function ListItem({ item, index }) {
  return (
    <Draggable draggableId={item.id.toString()} index={index}>
      {(provided, snapshot) => (
        <>
          <ListGroup.Item
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={{
              ...provided.draggableProps.style,
              opacity: snapshot.isDragging ? 0.5 : 1,
            }}
          >
            {item.order} - {item.name}
          </ListGroup.Item>
        </>
      )}
    </Draggable>
  );
}

export default Plv;
